import { LocViewBase } from './loc_view_base.js';
import { listenToEventSync } from '../util/listen_to_event.js';

class LocViewShorty extends LocViewBase {
  static markupType = 'shorty';
  static tagName = 'loc-view-shorty';

  initialize() {
    super.initialize();

    listenToEventSync(this, 'click', () => this.fireExpand());

    // Swipe up on collapsed stick panel expands it (mobile).
    listenToEventSync(this, 'touchstart', ev => {
      if (ev.changedTouches.length == 1) {
        this.touchStartX = ev.changedTouches[0].clientX;
        this.touchStartY = ev.changedTouches[0].clientY;
      }
    });

    listenToEventSync(this, 'touchend', ev => {
      if (ev.changedTouches.length == 1) {
        if (
          Math.abs(ev.changedTouches[0].clientX - this.touchStartX) <
          this.touchStartY - ev.changedTouches[0].clientY
        ) {
          this.fireExpand();
        }
      }
    });
  }
}

LocViewShorty.defineCustomElement();

export { LocViewShorty };
